import React, { useState } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
const OPTIONS = [{
  emoji: '🛡️',
  label: "I'm the go-to person in my family for security matters",
  route: '/assessment/self'
}, {
  emoji: '👤',
  label: 'I typically only oversee my own cybersecurity posture',
  route: '/assessment/self'
}, {
  emoji: '🤝',
  label: 'I usually look to others when it comes to online security',
  route: '/assessment/family'
}, {
  emoji: '💻',
  label: 'I work in IT or cybersecurity professionally',
  route: '/assessment/self'
}];
export function AssessmentPage() {
  const [selected, setSelected] = useState<number | null>(null);
  const navigate = useNavigate();
  const handleSelect = (index: number) => {
    setSelected(index);
    // Brief delay to show selection, then navigate to goals page
    setTimeout(() => {
      navigate('/assessment/goals', {
        state: {
          nextRoute: OPTIONS[index].route
        }
      });
    }, 400);
  };
  return <div className="w-full min-h-screen bg-[#f5f5f7] flex flex-col" data-id="element-499">
      {/* Top bar */}
      <div className="w-full px-5 pt-5 pb-3" data-id="element-500">
        <div className="max-w-md mx-auto flex items-center gap-4" data-id="element-501">
          <Link to="/intro-assessment" className="flex items-center justify-center w-10 h-10 -ml-2 text-gray-500 hover:text-[#631bb7] transition-colors" aria-label="Go back" data-id="element-502">
            <ArrowLeftIcon size={22} data-id="element-503" />
          </Link>
          {/* Progress bar */}
          <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-504">
            <div className="h-full bg-[#631bb7] rounded-full transition-all duration-500" style={{
            width: '10%'
          }} data-id="element-505" />
          </div>
        </div>
      </div>

      {/* Question */}
      <div className="flex-1 px-6 pt-6 pb-10" data-id="element-506">
        <div className="max-w-md mx-auto" data-id="element-507">
          <h1 className="md:text-[26px] mb-8 text-center text-[20px] font-[600] text-[#190647]" data-id="element-508">
            What best describes{' '}
            <span className="text-[#631bb7]" data-id="element-509">your role</span> when it comes to
            digital security?
          </h1>

          {/* Options */}
          <div className="space-y-3" data-id="element-510">
            {OPTIONS.map((option, i) => <button key={i} onClick={() => handleSelect(i)} className={`w-full flex items-center gap-3.5 px-5 py-4 rounded-2xl text-left transition-all duration-200 border-2 ${selected === i ? 'bg-[#631bb7] border-[#631bb7] text-white shadow-md' : 'bg-white border-gray-100 text-[#111111] hover:border-gray-200'}`} data-id="element-511">
                <span className="text-xl flex-shrink-0" aria-hidden="true" data-id="element-512">
                  {option.emoji}
                </span>
                <span className="text-[15px] leading-snug font-[500]" data-id="element-513">
                  {option.label}
                </span>
              </button>)}
          </div>
        </div>
      </div>
    </div>;
}